<template>
  <main>
    <div class="card">
      <div class="card-header">
          <h2>Consulta de documentos</h2>
      </div>
      <div class="card-body">
        <div class="d-flex flex-wrap">
          <div class="form-group col-3">
            <label for="">Certificado</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">Recibo</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">Factura</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">CUV</label>
            <input type="text" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">Fecha inicial</label>
            <input type="date" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label for="">Fecha final</label>
            <input type="date" class="form-control" />
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button class="btn btn-primary">Buscar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <h5 class="text-secondary">Resultados</h5>
        <div class="card-header-form">
          <input
            class="form-control search"
            type="search"
            placeholder="Buscar..."
          />
        </div>
      </div>
      <div class="card-body">
        <div class="col-12 d-flex justify-content-end mb-1">
          <button class="btn btn-sm btn-outline-info">
            <i class="fas fa-file-download"></i>
            Descargar
          </button>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered table-dark">
            <thead class="thead-dark">
              <td style="width: 20px; margin: 0 auto">
                <input type="checkbox">
              </td>
              <td>Tipo</td>
              <td>Número de póliza</td>
              <td>Número de documento</td>
              <td>Fecha inicial</td>
              <td>Fecha final</td>
              <td>RFC</td>
              <td>Desarrollador</td>
              <td>CUV</td>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  mounted() {
    this.$store.state.Loading = false;
  },
};
</script>

<style lang="scss">
.search {
  width: 300px;
  border-radius: 20px;
}
</style>